/** 根据规则以及实体拼接 update 语句 */
import { spliceWhereSQLFragmentByConditions } from './deleteSQL';
import { getQuoteByFieldType } from './field';
import { get } from './util';
/** 拼接 update 语句设置值的 sql */
export var spliceUpdateSQLFragmentByConditions = function (fnParams) {
    var connectors = fnParams.connectors, entity = fnParams.entity, params = fnParams.params, encrypt = fnParams.encrypt;
    return connectors
        .map(function (connector, index) {
        var from = connector.from, to = connector.to;
        var toFieldName = to.replace('/', '');
        var field = entity.fieldAry.find(function (f) { return f.name === toFieldName; });
        if (!field) {
            return undefined;
        }
        var fromNames = from.split('/').filter(Boolean);
        var value = get(params, fromNames);
        var q = getQuoteByFieldType(field.dbType);
        if (value === undefined) {
            return '';
        }
        return "".concat(index ? ', ' : '').concat(toFieldName, " = ").concat(value === null ? null : "".concat(q).concat(Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]' ? JSON.stringify(field.useEncrypt ? encrypt(value) : value) : (field.useEncrypt ? encrypt(value) : value)).concat(q));
    })
        .filter(Boolean)
        .join('');
};
export var spliceUpdateSQLByConditions = function (fnParams) {
    var conditions = fnParams.conditions, entities = fnParams.entities, params = fnParams.params, connectors = fnParams.connectors, isEdit = fnParams.isEdit, encrypt = fnParams.encrypt;
    var entityMap = {};
    entities.forEach(function (e) { return entityMap[e.id] = e; });
    var curEntity = entities.find(function (e) { return e.selected; });
    if (curEntity) {
        var sql = [];
        /** 前置 sql */
        // sql.push(`UPDATE ${curEntity.name}${isEdit ? '' : '__VIEW'} SET _UPDATE_USER_ID = "", _UPDATE_TIME = ${Date.now()}`);
        sql.push("UPDATE ".concat(curEntity.id, " SET"));
        sql.push(spliceUpdateSQLFragmentByConditions({
            connectors: connectors,
            entity: curEntity,
            params: params,
            encrypt: encrypt,
        }));
        sql.push(spliceWhereSQLFragmentByConditions({
            conditions: [conditions],
            params: params,
            curEntity: curEntity,
            entityMap: entityMap,
        }));
        return sql.join(' ');
    }
};
